(function(){
  function ready(fn){ if(document.readyState!='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  window.jvOpenDrawer=function(){var d=document.getElementById('jvDrawer'),s=document.getElementById('jvScrim');if(d)d.classList.add('open');if(s)s.classList.add('open');document.body.style.overflow='hidden';};
  window.jvCloseDrawer=function(){var d=document.getElementById('jvDrawer'),s=document.getElementById('jvScrim');if(d)d.classList.remove('open');if(s)s.classList.remove('open');document.body.style.overflow='';};
  ready(function(){
    var hdr=document.getElementById('jvHdr');
    if(hdr && hdr.classList.contains('home')){
      var onScroll=function(){hdr.classList.toggle('scrolled', (window.scrollY||window.pageYOffset)>60);};
      window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    }
    document.addEventListener('keydown',function(e){if(e.key==='Escape')window.jvCloseDrawer();});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
      document.querySelectorAll('.jv-reveal').forEach(function(el){io.observe(el);});
    } else {
      document.querySelectorAll('.jv-reveal').forEach(function(el){el.classList.add('in');});
    }
  });
  ready(function(){
    var f=document.querySelector('#jvlines form');
    if(!f) return;
    f.addEventListener('submit',function(){
      try{
        var keys=['contact[name]','contact[email]','contact[phone]','contact[Line of interest]','contact[Rooms]','contact[Zip]','contact[I am a]','contact[body]'];
        var p=new URLSearchParams(); p.append('source','lines-page');
        keys.forEach(function(n){var el=f.querySelector('[name="'+n+'"]'); if(el) p.append(n, el.value);});
        navigator.sendBeacon('https://n8n.iblda.com/webhook/jv-lead', p);
      }catch(e){}
    });
  });
})();
